import { Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import {
  HomePage,
  AboutPage,
  CertificationPage,
  GuidePage,
  NotFoundPage,
  NoticeListPage,
  NoticeDetailPage,
  NewsListPage,
  NewsDetailPage,
  FatwaListPage,
  FatwaDetailPage,
} from "@/pages";
import { BpjphPage } from "@/pages/recognition/Bpjph";

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/cert" element={<CertificationPage />} />
        <Route path="/notices" element={<NoticeListPage />} />
        <Route path="/notices/:id" element={<NoticeDetailPage />} />
        <Route path="/news" element={<NewsListPage />} />
        <Route path="/news/:id" element={<NewsDetailPage />} />
        <Route path="/fatwas" element={<FatwaListPage />} />
        <Route path="/fatwas/:id" element={<FatwaDetailPage />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/recognition/bpjph" element={<BpjphPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
